import { BUTTON_TYPES, Button } from 'components/Button'
import { Popup } from 'components/Popup'
import { Typography } from 'components/Typography'
import { BTN_TXT } from 'constants/txt'

import { useBankingSetupPopup } from 'features/MyCommunity/BankingSetupCommunity/Providers/BankingSetupPopupProvider'
import moment from 'moment'
import { useCallback, useMemo } from 'react'

export const ResolutionLinkGeneratedPopup = () => {
  const {
    resolutionLinkGeneratedPopup: { state, actions }
  } = useBankingSetupPopup()

  const { link, expires_on } = state.payload

  const onCancel = useCallback(() => {
    actions.close()
  }, [actions])

  const onOpenResolutionLink = useCallback(() => {
    if (!link) return
    window.open(link, '_blank')
  }, [link])

  const expiresIn = useMemo(() => {
    if (!expires_on) return 0
    const expiresIn = moment(expires_on).diff(moment(), 'days')
    return Number(expiresIn)
  }, [expires_on])

  return (
    <Popup
      {...state}
      width={442}
      zIndex={10000}
      className="generate-resolution-link-popup"
      onCancel={onCancel}
      footer={
        <Button
          type={BUTTON_TYPES.PRIMARY}
          upperCase
          onClick={onOpenResolutionLink}
        >
          {BTN_TXT.OPEN_RESOLUTION_LINK}
        </Button>
      }
    >
      <div className="column gap-16">
        <Typography.Body1>
          This secure link{' '}
          <b>
            expires in {expiresIn} day{expiresIn > 1 ? 's' : ''}
          </b>
          . If it expires, you will need to request a new one.
        </Typography.Body1>
      </div>
    </Popup>
  )
}
